import { Injectable } from '@angular/core';
import { HttpClientModule, HttpClient, HttpHeaders, HttpHeaderResponse, HttpRequest } from '@angular/common/http';
//import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs';
// import 'rxjs/add/operator/map';
import { map ,delay} from 'rxjs/operators';

import { AppGlobals } from '../shared/app.global';
import  dataurl from '../../assets/config.json';


  

@Injectable()
export class MasterService {

    callurl: string = '';
  
    clcd:string;
    aycd:string;
    usid:string;
    role:string;
    
        constructor(private http: HttpClient,private _global: AppGlobals) {
    
           this.clcd=localStorage.getItem('clcd');
           this.aycd=localStorage.getItem('aycd');
           this.usid=localStorage.getItem('usid');
           this.role=localStorage.getItem('role');
         
           this.callurl=_global.baseAPIUrl;
         }

getcurenttime()
{
    debugger
    let timenow= new Date().toString().split(' ')[4];
    return timenow;
}
         getdatetoday()
         {
          let d: Date = new Date();
          var mnth;
          var day='';
          //let todayDate = {year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate()};
          if(d.getMonth()>=9)
          {
            mnth=d.getMonth()+1;
          }
          else{
           // mnth='0'+d.getMonth()+1;
           mnth=d.getMonth()+1;
           mnth='0'+mnth;
          }
       
          if(d.getDate()>=10)
          {
            day=d.getDate().toString();
          }
          else{
            day='0'+d.getDate();
          }
          let todayDate =  d.getFullYear()+'-'+ mnth+'-' +day;
            
       return todayDate;
       
         }

           getmenuinfo(mnid) {
    debugger
//  var call= this.seturi();
//  console.log('url',call);
var pstdata={clcd:localStorage.getItem('clcd'),aycd:localStorage.getItem('aycd'),mnid:mnid,roleid:localStorage.getItem('role') };
  return this.http.post(this.callurl + 'getmenuinfo',pstdata)
      .pipe(map((data: any) => {
        console.log('menuinfo', data);
        
          return data.menuinfo;
      }))
}

          masbloodgroups(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'masbloodgroup/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.masbloodgroup;
                    
                }));
          }

          mascastecat(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'mascastecat/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.mascastecat;
                    
                }));
          }
          masacademicyear(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'masacademicyear/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.masacademicyear;
                    
                }));
          }
          massubcomb(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'sel_sp_exmsubcomb/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_exmsubcomb;
                    
                }));
          }

          mashouse(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'sel_sp_mashouse/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_mashouse;
                    
                }));
          }

          maspayopt(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'sel_sp_accpayoptions/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_accpayoptions;
                    
                }));
          }

          masfeequota(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'sel_sp_accfeequota/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_accfeequota;
                    
                }));
          }

          masmot(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'sel_sp_masmot/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_masmot;
                    
                }));
          }
          massection(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'sel_sp_massection/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_massection;
                    
                }));
          }

          sel_posts(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'sel_posts/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.arrbooth;
                    
                }));
          }
          mascourse(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'getmascourse/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.mascourse;
                    
                }));
          }
          masclass(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'sel_sp_masclass/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_masclass;
                    
                }));
          }

          sel_booth(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'sel_booth/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.arrbooth;
                    
                }));
          }

votoverviewbooth(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'votoverviewbooth/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.arrbooth;
                    
                }));
          }

votoverviewclass(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'votoverviewclass/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.arrclass;
                    
                }));
          }

          getcourse(): Observable<any> {

            var enqpost={clcd:this.clcd,aycd:this.aycd};
                
            //this.callurl='https://mycampuz.co.in/schoolpayment/admclasslist.php'
            
          
            // this.callurl=this.baseUrl+'Payenqrequest'
             return this.http.get(  this.callurl +"getmascourse/"+this.clcd+"/"+this.aycd )
                 .pipe(map((data: any) => 
                 {
                     console.log('clases',data);
                     return  data.mascourse ; 
                 }));
          } 

          getevlrooms(): Observable<any> {

            var enqpost={clcd:this.clcd,aycd:this.aycd};
                
            //this.callurl='https://mycampuz.co.in/schoolpayment/admclasslist.php'
            
          
            // this.callurl=this.baseUrl+'Payenqrequest'
             return this.http.get(  this.callurl +"getevlrooms/"+this.clcd+"/"+this.aycd )
                 .pipe(map((data: any) => 
                 {
                     console.log('clases',data);
                     return  data.rmlist ; 
                 }));
          } 
        
          classmasterrolewise(emid,crid,clid,oprtype): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'selmasclassbyrole/'+this.clcd+'/'+this.aycd+'/'+this.usid+'/'+this.role+'/'+crid+'/'+oprtype)
            .pipe(
                map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_masclass;
                    
                })

                // map((data:any) => {
                //     data.sp_masclass.selected = false;
                //     // or via brackets
                //     // obj['total'] = 2;
                //     return data.sp_masclass;
                // })
                
                );
          }

          masperiod(clid): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'getmasperiod/'+this.clcd+'/'+this.aycd+'/'+clid)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.masperiod;
                    
                }));
          }

          masattperiod(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'getattperiod/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.prlst;
                    
                }));
          }
          
          getpayipurl(): any {
            debugger
            return this.http.get(this.callurl + 'getpayip')
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data;
                    
                }));
         }
          sectionsrolewise(emid,crid,clid,oprtype): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'selmassectionbyrole/'+this.clcd+'/'+this.aycd+'/'+this.usid+'/'+this.role+'/'+clid+'/'+oprtype+"/"+crid)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_massection;
                    
                }));
          }

          getclasssection(classes: any): Observable<any> {
              debugger
           // secdata.clcd=this.clcd;
           // secdata.aycd=this.aycd;
            var pstdata={clcd:this.clcd,aycd:this.aycd,classes:classes};
              return this.http.post(this._global.baseAPIUrl + 'getclasssection', pstdata)
                  .pipe(map((data: any) => {
                      console.log('retres', data);
                      return data.sections;
                  }));
          }

          getstudentclasssecwise(classes: any): Observable<any> {
            debugger
         // secdata.clcd=this.clcd;
         // secdata.aycd=this.aycd;
          var pstdata={clcd:this.clcd,aycd:this.aycd,classes:classes};
            return this.http.post(this._global.baseAPIUrl + 'getstudentclasssecwise', pstdata)
                .pipe(map((data: any) => {
                    console.log('retres', data);
                    return data.stulst;
                }));
        }

        getstaffdeptwise(classes: any): Observable<any> {
            debugger
         // secdata.clcd=this.clcd;
         // secdata.aycd=this.aycd;
          var pstdata={clcd:this.clcd,aycd:this.aycd,depts:classes};
            return this.http.post(this._global.baseAPIUrl + 'getstaffdeptwise', pstdata)
                .pipe(map((data: any) => {
                    console.log('retres', data);
                    return data.emplst;
                }));
        }
          subjectsrolewise(emid,roleid,clid,oprtype,crid): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'selsubjectsbyrole/'+this.clcd+'/'+this.aycd+'/'+this.usid+'/'+this.role+'/'+clid+'/'+"subject/"+crid)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_massubjects;
                    
                }));
          }

          rptsubjectsrolewise(emid,roleid,clid,oprtype,crid): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'selsubjectsbyrole/'+this.clcd+'/'+this.aycd+'/'+this.usid+'/'+this.role+'/'+clid+'/'+oprtype+"/"+crid)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_massubjects;
                    
                }));
          }
          staffrolewise(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'selstaffbyrole/'+this.clcd+'/'+this.aycd+'/'+this.usid+'/'+this.role)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.stafflst;
                    
                }));
          }

          rptselstaffbyrole(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'rptselstaffbyrole/'+this.clcd+'/'+this.aycd+'/'+this.usid+'/'+this.role)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.stafflst;
                    
                }));
          }

            selemploys(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            var pstdata={clcd:this.clcd,aycd:this.aycd};
            return this.http.post(this.callurl + 'selemploys',pstdata)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.emplst;
                    
                }));
          }

           getsubjectstaff(crid,clid,scid,suid) {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'getsubjectstaff/'+this.clcd+'/'+this.aycd+'/'+crid+'/'+clid+'/'+scid+'/'+suid)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.arrstaff;
                    
                }));
          }
getfedrecrpt(crid,clid,scid,suid,emid) {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'getfedrecrpt/'+this.clcd+'/'+this.aycd+'/'+crid+'/'+clid+'/'+scid+'/'+suid+'/'+emid)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.arrfbres;
                    
                }));
          }
          sel_sp_massubgp() {
            let clcd=this.clcd;
            let aycd=this.aycd;
            return this.http.get(this._global.baseAPIUrl + 'sel_sp_massubgp/'+clcd+'/'+aycd)
                .pipe(map((data: any) => {
                    return data.sp_massubgp;
                }));
        }

        masacyear() {
            let clcd=this.clcd;
            let aycd=this.aycd;
            return this.http.get(this._global.baseAPIUrl + 'masacyear/'+clcd+'/'+aycd)
                .pipe(map((data: any) => {
                    return data.aylist;
                }));
        }
        save_sp_massubgp(secdata: any): Observable<any> {

            secdata.clcd=this.clcd;
            secdata.aycd=this.aycd;
            return this.http.post(this._global.baseAPIUrl + 'save_sp_massubgp', secdata)
                .pipe(map((data: any) => {
                    console.log('retres', 'response');
                    return data
                }));
        }

        sel_sp_massubcat() {

          let clcd=this.clcd;
            let aycd=this.aycd;
          return this.http.get(this._global.baseAPIUrl + 'sel_sp_massubcat/'+clcd+'/'+aycd)
              .pipe(map((data: any) => {
                  return data.sp_massubcat;
              }));
      }
      save_sp_massubcat(secdata: any): Observable<any> {
        secdata.clcd=this.clcd;
        secdata.aycd=this.aycd;
          return this.http.post(this._global.baseAPIUrl + 'save_sp_massubcat', secdata)
              .pipe(map((data: any) => {
                  console.log('retres', 'response');
                  return data
              }));
      }
  

      sel_sp_massubjects() {
        let clcd=localStorage.getItem('clcd');
        let aycd=localStorage.getItem('aycd');
        return this.http.get(this._global.baseAPIUrl + 'sel_sp_massubjects/'+clcd+'/'+aycd)
            .pipe(map((data: any) => {
                console.log('retres', data);
                return data.sp_massubjects;
            }));
    }

    getclasssub(clid) {
        let clcd=localStorage.getItem('clcd');
        let aycd=localStorage.getItem('aycd');
        return this.http.get(this._global.baseAPIUrl + 'getclasssub/'+clcd+'/'+aycd+'/'+clid)
            .pipe(map((data: any) => {
                console.log('retres', data);
                return data.sp_massubjects;
            }));
    }
    save_sp_massubjects(secdata: any): Observable<any> {
        secdata.clcd=this.clcd;
        secdata.aycd=this.aycd;
        return this.http.post(this._global.baseAPIUrl + 'save_sp_massubjects', secdata)
            .pipe(map((data: any) => {
                console.log('retres', 'response');
                return data
            }));
    }


    sel_sp_exmsubcomb() {
      let clcd=localStorage.getItem('clcd');
      let aycd=localStorage.getItem('aycd');
      return this.http.get(this._global.baseAPIUrl + 'sel_sp_exmsubcomb/'+clcd+'/'+aycd)
          .pipe(map((data: any) => {
              return data.sp_exmsubcomb;
          }));
  }

  sel_cursucbd(sucbid,clid,crid) {
    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
    return this.http.get(this._global.baseAPIUrl + 'sel_cursucbd/'+clcd+'/'+aycd+'/'+sucbid+'/'+clid+'/'+crid)
        .pipe(map((data: any) => {
            return data.cursucbdlst;
        }));
}
  save_sp_exmsubcomb(secdata: any): Observable<any> {
    secdata.clcd=this.clcd;
    secdata.aycd=this.aycd;
    secdata.usid=this.usid;
      return this.http.post(this._global.baseAPIUrl + 'save_sp_exmsubcomb', secdata)
          .pipe(map((data: any) => {
              console.log('retres', 'response');
              return data
          }));
  }

  upd_cursucbd(secdata: any): Observable<any> {
    secdata.clcd=this.clcd;
    secdata.aycd=this.aycd;
    secdata.usid=this.usid;
      return this.http.post(this._global.baseAPIUrl + 'update_cursucbd', secdata)
          .pipe(map((data: any) => {
              console.log('retres', 'response');
              return data
          }));
  }

 save_cursucbd(secdata: any): Observable<any> {
    secdata.clcd=this.clcd;
    secdata.aycd=this.aycd;
    secdata.usid=this.usid;
      return this.http.post(this._global.baseAPIUrl + 'save_cursucbd', secdata)
          .pipe(map((data: any) => {
              console.log('retres', 'response');
              return data
          }));
  }
  sel_sp_masasshead() {

    let clcd=this.clcd;
    let aycd=this.aycd;
    return this.http.get(this._global.baseAPIUrl + 'sel_sp_masasshead/'+clcd+'/'+aycd)
        .pipe(map((data: any) => {
            return data.sp_masasshead;
        }))
}

sel_sp_masasstype() {
    let clcd=this.clcd;
    let aycd=this.aycd;
    return this.http.get(this._global.baseAPIUrl + 'sel_sp_masasstype/'+clcd+'/'+aycd)
        .pipe(map((data: any) => {
            return data.sp_masasstype;
        }))
}

selbatch() {
    let clcd=this.clcd;
    let aycd=this.aycd;
    return this.http.get(this._global.baseAPIUrl + 'selevlbatch/'+clcd+'/'+aycd)
        .pipe(map((data: any) => {
            return data.arrbatch;
        }))
}
masclasssubject(clssubdata: any): Observable<any> {
    clssubdata.clcd=this.clcd;
    clssubdata.aycd=this.aycd;
    clssubdata.usid=this.usid;
    return this.http.post(this._global.baseAPIUrl + 'by_sp_masclasssubject', clssubdata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data.by_sp_clsSub;
        }));
}

masevpattern(clssubdata: any): Observable<any> {
    clssubdata.clcd=this.clcd;
    clssubdata.aycd=this.aycd;
    return this.http.post(this._global.baseAPIUrl + 'sel_evlpattern', clssubdata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data.arrevlst;
        }));
}

sel_evlmarks_subject(clssubdata: any): Observable<any> {
    clssubdata.clcd=this.clcd;
    clssubdata.aycd=this.aycd;
    return this.http.post(this._global.baseAPIUrl + 'sel_evlmarks_subject', clssubdata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data.arrevlst;
        }));
}

updatemaxmin(clssubdata: any): Observable<any> {
    clssubdata.clcd=this.clcd;
    clssubdata.aycd=this.aycd;
    clssubdata.usid=this.usid;
    return this.http.post(this._global.baseAPIUrl + 'upd_evlmaxminmarks', clssubdata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }));
}
updatemaxmin1(clssubdata: any): Observable<any> {
    clssubdata.clcd=this.clcd;
    clssubdata.aycd=this.aycd;
    clssubdata.usid=this.usid;
    return this.http.post(this._global.baseAPIUrl + 'upd_evlmaxminmarks1', clssubdata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }));
}

showhidescores(clssubdata: any): Observable<any> {
    clssubdata.clcd=this.clcd;
    clssubdata.aycd=this.aycd;
    clssubdata.usid=this.usid;
    return this.http.post(this._global.baseAPIUrl + 'showhidescores', clssubdata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }));
}
saveevpattern(clssubdata: any): Observable<any> {
    clssubdata.clcd=this.clcd;
    clssubdata.aycd=this.aycd;
    clssubdata.usid=this.usid;
    return this.http.post(this._global.baseAPIUrl + 'save_evlpattern', clssubdata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }));
}
save_sp_masasshead(secdata: any): Observable<any> {
    secdata.clcd=this.clcd;
    secdata.aycd=this.aycd;
    secdata.usid=this.usid;
    return this.http.post(this._global.baseAPIUrl + 'save_sp_masasshead', secdata)
        .pipe(map((data: any) => {
            console.log('retres', 'response');
            return data
        }));
}


save_sp_masasstype(secdata: any): Observable<any> {
    secdata.clcd=this.clcd;
    secdata.aycd=this.aycd;
    secdata.usid=this.usid;
    return this.http.post(this._global.baseAPIUrl + 'save_sp_masasstype', secdata)
        .pipe(map((data: any) => {
            console.log('retres', 'response');
            return data
        }));
}
save_sp_masclasssubject(clsdata: any): Observable<any> {
    clsdata.clcd=this.clcd;
    clsdata.aycd=this.aycd;
    clsdata.usid=this.usid;
    return this.http.post(this._global.baseAPIUrl + 'save_sp_masclasssubject', clsdata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }));
}

saveclassdtls(clsdata: any): Observable<any> {
    clsdata.clcd1=this.clcd;
    clsdata.aycd=this.aycd;
    return this.http.post(this._global.baseAPIUrl + 'save_sp_masclass', clsdata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }));
}

save_booth(clsdata: any): Observable<any> {
    clsdata.clcd1=this.clcd;
    clsdata.aycd=this.aycd;
      clsdata.usid=this.usid;
    return this.http.post(this._global.baseAPIUrl + 'save_booth', clsdata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }));
}

savemascourse(clsdata: any): Observable<any> {
    clsdata.clcd=this.clcd;
    clsdata.aycd=this.aycd;
    return this.http.post(this._global.baseAPIUrl + 'save_mascourse', clsdata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }));
}

savesection(clsdata: any): Observable<any> {
    clsdata.clcd=this.clcd;
    clsdata.aycd=this.aycd;
    return this.http.post(this._global.baseAPIUrl + 'save_sp_massection', clsdata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }));
}
save_posts(clsdata: any): Observable<any> {
    clsdata.clcd=this.clcd;
    clsdata.aycd=this.aycd;
    clsdata.usid=this.usid;
    return this.http.post(this._global.baseAPIUrl + 'save_posts', clsdata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }));
}

sel_sp_masoccation() {
    let clcd=this.clcd;
    let aycd=this.aycd;
    return this.http.get(this._global.baseAPIUrl + 'sel_sp_masoccation/'+clcd+'/'+aycd)
        .pipe(map((data: any) => {
            return data.sp_masoccation;
        }))
}
save_sp_masoccation(secdata: any): Observable<any> {
    return this.http.post(this._global.baseAPIUrl + 'save_sp_masoccation', secdata)
        .pipe(map((data: any) => {
            console.log('retres', 'response');
            return data
        }));
}

sel_sp_hrmdesig() {
    let clcd=this.clcd;
    let aycd=this.aycd;
    return this.http.get(this._global.baseAPIUrl + 'sel_sp_hrmdesig/'+clcd+'/'+aycd)
        .pipe(map((data: any) => {
            return data.sp_hrmdesig;
        }))
}

Save_hrmdesig(rd) {
    let clcd=this.clcd;
    let aycd=this.aycd;
    var pdata={clcd:this.clcd,aycd:this.aycd,desid:rd.desid,desnm:rd.desnm,descd:rd.descd,sort:rd.sort,crby:this.usid,mdby:this.usid,oprtag:rd.oprtag};
    return this.http.post(this._global.baseAPIUrl + 'save_sp_hrmdesig',pdata)
        .pipe(map((data: any) => {
            console.log('dept',data);
            return data;
        }))
}


get_hrmdept() {
    let clcd=this.clcd;
    let aycd=this.aycd;
    return this.http.get(this._global.baseAPIUrl + 'sel_sp_hrmdept/'+clcd+'/'+aycd)
        .pipe(map((data: any) => {
            console.log('dept',data);
            return data.sp_hrmdept;
        }))
}

delhrmdesig(desid) {
    let clcd=this.clcd;
    let aycd=this.aycd;
    return this.http.get(this._global.baseAPIUrl + 'delhrmdesig/'+clcd+'/'+aycd+'/'+desid)
        .pipe(map((data: any) => {
            console.log('dept',data);
            return data;
        }))
}

delhrmdept(depid) {
    let clcd=this.clcd;
    let aycd=this.aycd;
    return this.http.get(this._global.baseAPIUrl + 'delhrmdept/'+clcd+'/'+aycd+'/'+depid)
        .pipe(map((data: any) => {
            console.log('dept',data);
            return data;
        }))
}


Save_hrdept(rd) {
    let clcd=this.clcd;
    let aycd=this.aycd;
    var pdata={clcd:this.clcd,aycd:this.aycd,depid:rd.depid,depnm:rd.depnm,depcd:rd.depcd,sort:rd.sort,crby:this.usid,mdby:this.usid,oprtag:rd.oprtag};
    return this.http.post(this._global.baseAPIUrl + 'save_sp_hrmdept',pdata)
        .pipe(map((data: any) => {
            console.log('dept',data);
            return data;
        }))
}

getacfeechart(oprtype: any,sertxt): Observable<any> {
    debugger
    var pstdata={clcd:this.clcd,aycd:this.aycd,oprtype:oprtype,sertxt:sertxt};
    return this.http.post(this._global.baseAPIUrl + 'getacfeechart', pstdata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data.feelist
        }));
}

getacfeechartdet(objdet:any): Observable<any> {
    //var pstdata={clcd:this.clcd,aycd:this.aycd,oprtype:oprtype,sertxt:sertxt};
    objdet.clcd=this.clcd;
    objdet.aycd=this.aycd;
    objdet.usid=this.usid;
    objdet.oprtype='seldet';
    return this.http.post(this._global.baseAPIUrl + 'getacfeechartdet', objdet)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data.feelistdet
        }));
}


getacchead(acstatus) {
    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
    return this.http.get(this._global.baseAPIUrl + 'sel_sp_accaccounthead/'+clcd+'/'+aycd+'/'+acstatus)
        .pipe(map((data: any) => {
            return data.accheadlist;
        }));
}





saveacfeechart(objdet:any): Observable<any> {
    //var pstdata={clcd:this.clcd,aycd:this.aycd,oprtype:oprtype,sertxt:sertxt};
    objdet.clcd=this.clcd;
    objdet.aycd=this.aycd;
    objdet.usid=this.usid;
    //objdet.oprtype='seldet';
    return this.http.post(this._global.baseAPIUrl + 'saveacfeechart', objdet)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data
        }));
}

delacfeechart(rid:any): Observable<any> {
    var pstdata={clcd:this.clcd,aycd:this.aycd,rid:rid};
    // objdet.clcd=this.clcd;
    // objdet.aycd=this.aycd;
    // objdet.usid=this.usid;
    //objdet.oprtype='seldet';
    return this.http.post(this._global.baseAPIUrl + 'delacfeechart', pstdata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data
        }));
}

getinstallment() {
    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
    return this.http.get(this._global.baseAPIUrl + 'sel_sp_accinstallment/'+clcd+'/'+aycd)
        .pipe(map((data: any) => {
            return data.sp_accinstallments;
        }));
}


masinstallment(): Observable<any> {
    debugger
    // let clcd=localStorage.getItem('clcd');
    // let aycd=localStorage.getItem('aycd');libsubjectgroup
    
    return this.http.get(this.callurl + 'sel_sp_accinstallment/'+this.clcd+'/'+this.aycd)
    .pipe(map((data: any) => {
            console.log('masinsta-data', data);
            return data.sp_accinstallments;
            
        }));
  }
  
  
  saveinstadtls(instadata: any): Observable<any> {
    debugger
    instadata.clcd=this.clcd;
    instadata.aycd=this.aycd;
    return this.http.post(this._global.baseAPIUrl + 'save_sp_accinstallment', instadata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }));
  }

// FeeQuta Service

masfeequta(): Observable<any> {
    debugger
  
    return this.http.get(this.callurl + 'sel_sp_accfeequota/'+this.clcd+'/'+this.aycd)
    .pipe(map((data: any) => {
            console.log('masfeequota', data);
            return data.sp_accfeequota;
            
        }));
  }

  savefeqdetails(feqtadata: any): Observable<any> {
    debugger
    feqtadata.clcd=this.clcd;
    feqtadata.aycd=this.aycd;
    return this.http.post(this._global.baseAPIUrl + 'save_sp_accfeequota', feqtadata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }));
  }

// Accounts Head Service
masacchead(status): Observable<any> {
    debugger

    return this.http.get(this.callurl + 'sel_sp_accaccounthead/'+this.clcd+'/'+this.aycd+'/'+status)
    .pipe(map((data: any) => {
            console.log('masacchead', data);
            return data.accheadlist;
            
        }));
  }


  saveaachdetails(acchdata: any): Observable<any> {
    debugger
    acchdata.clcd=this.clcd;
    acchdata.aycd=this.aycd;
    acchdata.usid=this.usid;
    console.log('data', acchdata);
    return this.http.post(this._global.baseAPIUrl + 'save_sp_accaccounthead', acchdata)
        .pipe(map((data: any) => {
         
            console.log('retres ACH', data);
            return data;
        }));
  }


  //Account Cat
  masacccat(): Observable<any> {
    debugger

    return this.http.get(this.callurl + 'sel_sp_acccat/'+this.clcd+'/'+this.aycd)
    .pipe(map((data: any) => {
            console.log('masacchead', data);
            return data.sp_acccat;
            
        }));
  }

  savecatadtls(accatdata:any):Observable<any> {
    debugger
    accatdata.clcd=this.clcd;
    accatdata.aycd=this.aycd;
    accatdata.usid=this.usid;
    console.log('data',accatdata);
    return this.http.post(this._global.baseAPIUrl + 'save_sp_acccat',accatdata)
    .pipe(map((data:any)=>{
        console.log('data',data);
        return data;
    }));
}

//Payment Option

maspayop(): Observable<any> {
    debugger

    return this.http.get(this.callurl + 'sel_sp_accpayoptions/'+this.clcd+'/'+this.aycd)
    .pipe(map((data: any) => {
            console.log('maspayop', data);
            return data.sp_accpayoptions;
            
        }));
  }


  savepayop(payop:any):Observable<any> {
    debugger
    payop.clcd=this.clcd;
    payop.aycd=this.aycd;
    payop.usid=this.usid;
    console.log('data',payop);
    return this.http.post(this._global.baseAPIUrl + 'save_sp_accpayoptions',payop)
    .pipe(map((data:any)=>{
        console.log('data',data);
        return data;
    }));
}

// mot 

masmotransaction(): Observable<any> {
    debugger

    return this.http.get(this.callurl + 'sel_sp_accmot/'+this.clcd+'/'+this.aycd)
    .pipe(map((data: any) => {
            console.log('maspayop', data);
            return data.sp_accmmot;
            
        }));
  }

  savemot(mot:any):Observable<any> {
    debugger
    mot.clcd=this.clcd;
    mot.aycd=this.aycd;
    mot.usid=this.usid;
    console.log('data',mot);
    return this.http.post(this._global.baseAPIUrl + 'save_sp_mot',mot)
    .pipe(map((data:any)=>{
        console.log('data',data);
        return data;
    }));
}

getstudent(clid:number,secid:number,brid:string): Observable<any> {
    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
    return this.http.get(this._global.baseAPIUrl + 'sp_student/'+clid+'/'+secid+'/dbnm/'+clcd+'/'+aycd+'/'+brid)
        .pipe(map((data: any) => {
            console.log('retres', 'response');
            return data.by_sp_clsSec;
        }));
}

getmasmtongue(): Observable<any> {
    debugger
    // let clcd=localStorage.getItem('clcd');
    // let aycd=localStorage.getItem('aycd');libsubjectgroup
    
    return this.http.get(this.callurl + 'getmothertongue/'+this.clcd+'/'+this.aycd)
    .pipe(map((data: any) => {
            console.log('retres-data', data);
            return data.motlst;
            
        }));
  }


  masgeneral(tag): Observable<any> {
    debugger
    // let clcd=localStorage.getItem('clcd');
    // let aycd=localStorage.getItem('aycd');libsubjectgroup
    
    return this.http.get(this.callurl + 'getmasgeneral/'+this.clcd+'/'+this.aycd+'/'+tag)
    .pipe(map((data: any) => {
            console.log('retres-data', data);
            return data.masgeneralst;
            
        }));
  }

  combinedclass() {
    let clcd=this.clcd;
    let aycd=this.aycd;
    return this.http.get(this._global.baseAPIUrl + 'getcombclass/'+clcd+'/'+aycd)
        .pipe(map((data: any) => {
            return data.arrcmbcls;
        }));
}

  combinedclass_new() {
    let clcd=this.clcd;
    let aycd=this.aycd;
    return this.http.get(this._global.baseAPIUrl + 'getcombclass_new/'+clcd+'/'+aycd)
        .pipe(map((data: any) => {
            return data.arrcmbcls;
        }));
}

attcombinedclass() {
    let clcd=this.clcd;
    let aycd=this.aycd;
    return this.http.get(this._global.baseAPIUrl + 'selcmbclassbyrole/'+clcd+'/'+aycd+'/'+this.usid+'/'+this.role)
        .pipe(map((data: any) => {
            return data.arrcmbcls;
        }));
}
savecmbclass(mot:any):Observable<any> {
    debugger
    mot.clcd=this.clcd;
    mot.aycd=this.aycd;
    mot.usid=this.usid;
    console.log('data',mot);
    return this.http.post(this._global.baseAPIUrl + 'savecmbclass',mot)
    .pipe(map((data:any)=>{
        console.log('data',data);
        return data;
    }));
}


savecmbclass_new(mot:any):Observable<any> {
    debugger
    mot.clcd=this.clcd;
    mot.aycd=this.aycd;
    mot.usid=this.usid;
    console.log('data',mot);
    return this.http.post(this._global.baseAPIUrl + 'savecmbclass_new',mot)
    .pipe(map((data:any)=>{
        console.log('data',data);
        return data;
    }));
}


getstuforcmb(obj) {
    let clcd=this.clcd;
    let aycd=this.aycd;
    let clid=obj.clid;
    let scid=obj.scid;
    let crid=obj.crid;
    let cbclid=obj.cbclid;
    let baid=obj.baid;
    return this.http.get(this._global.baseAPIUrl + 'getstuforcombclass/'+clcd+'/'+aycd+'/'+cbclid+'/'+clid+'/'+scid+'/'+crid+'/0')
        .pipe(map((data: any) => {
            console.log('data', data);
            // return data.arrstulst;
            return data;
        }));
}

getevlcopomaster(oprtype,suid) {

    let clcd=this.clcd;
    let aycd=this.aycd;
    return this.http.get(this._global.baseAPIUrl + 'getevlcopomaster/'+clcd+'/'+aycd+'/'+oprtype+'/'+suid)
        .pipe(map((data: any) => {
            return data.evlcopomaster;
        }))
}


saveevlcopomaster(secdata: any): Observable<any> {
    secdata.clcd=this.clcd;
    secdata.aycd=this.aycd;
    secdata.usid=this.usid;
    return this.http.post(this._global.baseAPIUrl + 'saveevlcopomaster', secdata)
        .pipe(map((data: any) => {
            console.log('retres', 'response');
            return data
        }));
}

sel_evlmanstype(): Observable<any> {
    debugger
    // let clcd=localStorage.getItem('clcd');
    // let aycd=localStorage.getItem('aycd');libsubjectgroup
    
    return this.http.get(this.callurl + 'sel_evlmanstype')
    .pipe(map((data: any) => {
            console.log('retres-data', data);
            return data.arrevlmanstype;
            
        }));
  }

  sel_evlmqsegment(): Observable<any> {
    debugger
    // let clcd=localStorage.getItem('clcd');
    // let aycd=localStorage.getItem('aycd');libsubjectgroup
    
    return this.http.get(this.callurl + 'sel_evlmqsegment')
    .pipe(map((data: any) => {
            console.log('retres-data', data);
            return data.arrevlmqsegment;
            
        }));
  }

  sel_evlmqcategory(): Observable<any> {
    debugger
    // let clcd=localStorage.getItem('clcd');
    // let aycd=localStorage.getItem('aycd');libsubjectgroup
    
    return this.http.get(this.callurl + 'sel_evlmqcategory')
    .pipe(map((data: any) => {
            console.log('retres-data', data);
            return data.arrevlmqcategory;
            
        }));
  }


  sel_evlmqbank(oprtype,tag): Observable<any> {
    debugger
    // let clcd=localStorage.getItem('clcd');
    // let aycd=localStorage.getItem('aycd');libsubjectgroup
    
    return this.http.get(this.callurl + 'sel_evlmqbank/'+oprtype+'/'+tag)
    .pipe(map((data: any) => {
            console.log('retres-data', data);
            return data.arrquestions;
            
        }));
  }

  sel_evlmquestions(tag): Observable<any> {
    debugger
    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
    
    return this.http.get(this.callurl + 'sel_evlmquestions/'+clcd+'/'+aycd+'/'+tag)
    .pipe(map((data: any) => {
            console.log('retres-data', data);
            return data.arrquestions;
            
        }));
  }

  save_evlmqbank(rd: any,data:File): Observable<any> {
debugger;
    const formData: FormData = new FormData();
    //console.log("stuid",bkid)
    if(data==null)
    {
       // formData.append('Image', data, '');
        formData.append('isphotouploaded', 'NO');

    }
    else
    {
    formData.append('Image', data, data.name);
    formData.append('isphotouploaded', 'YES');
    }
      

      formData.append('oprtype', rd.oprtype);
      formData.append('usid',this.usid);
      formData.append('quid', rd.quid);
      formData.append('qudis', rd.qudis);
      formData.append('qusegid', rd.qusegid);
      formData.append('qucatid', rd.qucatid);
      formData.append('anstypeid', rd.anstypeid);
      formData.append('imgpath', rd.imgpath);
      formData.append('inid', rd.inid);
   
      console.log("formData",formData);
    // secdata.clcd=this.clcd;
    // secdata.inid=this.aycd;
    //secdata.usid=this.usid;
    return this.http.post(this.callurl + 'save_evlmqbank', formData)
        .pipe(map((data: any) => {
            console.log('retres', 'response');
            return data
        }));
}


sel_evlmanswer(quid): Observable<any> {
    debugger
    // let clcd=localStorage.getItem('clcd');
    // let aycd=localStorage.getItem('aycd');libsubjectgroup
    
    return this.http.get(this.callurl + 'sel_evlmanswer/'+quid)
    .pipe(map((data: any) => {
            console.log('retres-data', data);
            return data.arrevlmanswer;
            
        }));
  }


  save_evlmanswer(mot:any):Observable<any> {
    debugger
    // mot.clcd=this.clcd;
    // mot.aycd=this.aycd;
    // mot.usid=this.usid;
    console.log('data',mot);
    return this.http.post(this.callurl+ 'save_evlmanswer',mot)
    .pipe(map((data:any)=>{
        console.log('data',data);
        return data;
    }));
}


sel_evlmqpaperd(suid) {

    let clcd=this.clcd;
    let aycd=this.aycd;
    return this.http.get(this._global.baseAPIUrl + 'sel_evlmqpaperd/'+clcd+'/'+aycd+'/'+suid)
        .pipe(map((data: any) => {
            console.log('data',data);
            return data.arrevlmqpaperd;
        }))
}

save_evlmqpaperd(mot:any):Observable<any> {
    debugger
    mot.clcd=this.clcd;
    mot.aycd=this.aycd;
    mot.usid=this.usid;
    mot.inid=localStorage.getItem('masclid');
    console.log('data',mot);
    return this.http.post(this.callurl+ 'save_evlmqpaperd',mot)
    .pipe(map((data:any)=>{
        console.log('data',data);
        return data;
    }));
}

sel_evlmqpaperh() {

    let clcd=this.clcd;
    let aycd=this.aycd;
    return this.http.get(this._global.baseAPIUrl + 'sel_evlmqpaperh/'+clcd+'/'+aycd)
        .pipe(map((data: any) => {
            return data.arrevlmqpaperh;
        }))
}


save_evlmqpaperh(mot:any):Observable<any> {
    debugger
    mot.clcd=this.clcd;
    mot.aycd=this.aycd;
    mot.usid=this.usid;
    mot.inid=localStorage.getItem('masclid');
    console.log('data',mot);
    return this.http.post(this.callurl+ 'save_evlmqpaperh',mot)
    .pipe(map((data:any)=>{
        console.log('data',data);
        return data;
    }));
}


 formatDate(d) {
    var myDate = new Date(d);
    var hrs = ((myDate.getHours() > 12) ? myDate.getHours()-12 : myDate.getHours());
    var amPM = ((myDate.getHours() >= 12) ? "PM" : "AM");

    if (hrs==0) hrs = 12;

    var formattedDate = (myDate.getMonth() + 1) + "-" + myDate.getDate() + "-" + myDate.getFullYear() + " " + hrs + ":" + myDate.getMinutes() + " " + amPM;

    return formattedDate;
}

save_evltbluebook(mot:any):Observable<any> {
    debugger
    mot.clcd=this.clcd;
    mot.aycd=this.aycd;
    mot.usid=this.usid;
    mot.stdt=mot.stdt.replace('T',' ');
    mot.endt=mot.endt.replace('T',' ');
    console.log('data',mot);
    return this.http.post(this.callurl+ 'save_evltceschedule',mot)
    .pipe(map((data:any)=>{
        console.log('data',data);
        return data;
    }));
}

sel_evltbluebook() {

    let clcd=this.clcd;
    let aycd=this.aycd;
    return this.http.get(this._global.baseAPIUrl + 'sel_evltceschedule/'+clcd+'/'+aycd)
        .pipe(map((data: any) => {
            return data.arrevlmqpaperd;
        }))
}

sel_evlresult(cesid) {

    let clcd=this.clcd;
    let aycd=this.aycd;
    return this.http.get(this._global.baseAPIUrl + 'sel_evlresult/'+clcd+'/'+aycd+'/'+cesid)
        .pipe(map((data: any) => {
            return data.arrevlresult;
        }))
}

masposts(): Observable<any> {
    debugger
    // let clcd=localStorage.getItem('clcd');
    // let aycd=localStorage.getItem('aycd');libsubjectgroup
    
    return this.http.get(this.callurl + 'getposts/'+this.clcd+'/'+this.aycd)
    .pipe(map((data: any) => {
            console.log('retres-data', data);
            return data.postdata;
            
        }));
  }


  masbooth(): Observable<any> {
    debugger
    // let clcd=localStorage.getItem('clcd');
    // let aycd=localStorage.getItem('aycd');libsubjectgroup
    
    return this.http.get(this.callurl + 'getbooth/'+this.clcd+'/'+this.aycd)
    .pipe(map((data: any) => {
            console.log('retres-data', data);
            return data.postdata;
            
        }));
  }

  getlibrectype(): Observable<any> {
    debugger

    return this.http.get(this.callurl + 'getlibrectype/'+this.clcd+'/'+this.aycd)
    .pipe(map((data: any) => {
            console.log('masacchead', data);
            return data.sp_acccat;
            
        }));
  }

  getrecbooks(): Observable<any> {
    debugger

    return this.http.get(this.callurl + 'getrecbooks/'+this.clcd+'/'+this.aycd)
    .pipe(map((data: any) => {
            console.log('masacchead', data);
            return data.accheadlist;
            
        }));
  }

     save_hombuilding(secdata: any): Observable<any> {
        secdata.clcd=this.clcd;
        secdata.aycd=this.aycd;
        secdata.usid=this.usid;
          return this.http.post(this._global.baseAPIUrl + 'save_hombuilding', secdata)
              .pipe(map((data: any) => {
                  console.log('retres', 'response');
                  return data
              }));
      }

       gethombuilding() {

          let clcd=this.clcd;
            let aycd=this.aycd;
          return this.http.get(this._global.baseAPIUrl + 'gethombuilding/'+clcd+'/'+aycd)
              .pipe(map((data: any) => {
                  return data.arritem;
              }));
      }

         save_homrmcat(secdata: any): Observable<any> {
        secdata.clcd=this.clcd;
        secdata.aycd=this.aycd;
        secdata.usid=this.usid;
          return this.http.post(this._global.baseAPIUrl + 'save_homrmcat', secdata)
              .pipe(map((data: any) => {
                  console.log('retres', 'response');
                  return data
              }));
      }

           gethomrmcat() {

          let clcd=this.clcd;
            let aycd=this.aycd;
          return this.http.get(this._global.baseAPIUrl + 'gethomrmcat/'+clcd+'/'+aycd)
              .pipe(map((data: any) => {
                  return data.arritem;
              }));
      }

       gethomrmloc() {

          let clcd=this.clcd;
            let aycd=this.aycd;
          return this.http.get(this._global.baseAPIUrl + 'gethomrmloc/'+clcd+'/'+aycd)
              .pipe(map((data: any) => {
                  return data.arritem;
              }));
      }


      save_homrmloc(secdata: any): Observable<any> {
        secdata.clcd=this.clcd;
        secdata.aycd=this.aycd;
        secdata.usid=this.usid;
          return this.http.post(this._global.baseAPIUrl + 'save_homrmloc', secdata)
              .pipe(map((data: any) => {
                  console.log('retres', 'response');
                  return data
              }));
      }

      gethomroom() {

          let clcd=this.clcd;
            let aycd=this.aycd;
          return this.http.get(this._global.baseAPIUrl + 'gethomroom/'+clcd+'/'+aycd)
              .pipe(map((data: any) => {
                  return data.arritem;
              }));
      }

      save_homroom(secdata: any): Observable<any> {
        secdata.clcd=this.clcd;
        secdata.aycd=this.aycd;
        secdata.usid=this.usid;
          return this.http.post(this._global.baseAPIUrl + 'save_homroom', secdata)
              .pipe(map((data: any) => {
                  console.log('retres', 'response');
                  return data
              }));
      }


      gethombed() {

          let clcd=this.clcd;
            let aycd=this.aycd;
          return this.http.get(this._global.baseAPIUrl + 'gethombed/'+clcd+'/'+aycd)
              .pipe(map((data: any) => {
                  return data.arritem;
              }));
      }

      save_hombed(secdata: any): Observable<any> {
        secdata.clcd=this.clcd;
        secdata.aycd=this.aycd;
        secdata.usid=this.usid;
          return this.http.post(this._global.baseAPIUrl + 'save_hombed', secdata)
              .pipe(map((data: any) => {
                  console.log('retres', 'response');
                  return data
              }));
      }

      ///// OBEM Masters ///////

      getobemlevels() {

    let clcd=this.clcd;
    let aycd=this.aycd;
    return this.http.get(this._global.baseAPIUrl + 'getobemlevels/'+clcd+'/'+aycd)
        .pipe(map((data: any) => {
             console.log('retres', data);
            return data.arrobemlevels;
        }))
}


getobempo(crid) {

    let clcd=this.clcd;
    let aycd=this.aycd;
    return this.http.get(this._global.baseAPIUrl + 'getobempo/'+clcd+'/'+aycd+'/'+crid)
        .pipe(map((data: any) => {
            return data.arrobempo;
        }))
}

getobemtmethod() {

    let clcd=this.clcd;
    let aycd=this.aycd;
    return this.http.get(this._global.baseAPIUrl + 'getobemtmethod/'+clcd+'/'+aycd)
        .pipe(map((data: any) => {
            return data.arrobemtmethod;
        }))
}

getobemco(obj) {

    obj.clcd=this.clcd;
    obj.aycd=this.aycd;
    return this.http.post(this._global.baseAPIUrl + 'getobemco',obj)
        .pipe(map((data: any) => {
            console.log('data', data);
            return data.arrobemco;
        }))
}

getobemtcopo(obj,oprtype) {

    obj.clcd=this.clcd;
    obj.aycd=this.aycd;
    obj.oprtype=oprtype;
    return this.http.post(this._global.baseAPIUrl + 'getobemtcopo',obj)
        .pipe(map((data: any) => {
            console.log('data', data);
            return data.arrobemco;
        }))
}

getobemtpmap(obj) {

    obj.clcd=this.clcd;
    obj.aycd=this.aycd;
    return this.http.post(this._global.baseAPIUrl + 'getobemtpmap',obj)
        .pipe(map((data: any) => {
            console.log('data', data);
            return data.arrobemtpmap;
        }))
}
getobemtpmap1(obj) {

    obj.clcd=this.clcd;
    obj.aycd=this.aycd;
    return this.http.post(this._global.baseAPIUrl + 'getobemtpmap1',obj)
        .pipe(map((data: any) => {
            return data.arrobemtpmap;
        }))
}

getobetlp(obj) {

    obj.clcd=this.clcd;
    obj.aycd=this.aycd;
    return this.http.post(this._global.baseAPIUrl + 'getobetlp',obj)
        .pipe(map((data: any) => {
            return data.arrobetlp;
        }))
}

getobemtpmapserch(obj) {

    obj.clcd=this.clcd;
    obj.aycd=this.aycd;
    return this.http.post(this._global.baseAPIUrl + 'getobemtpsearch',obj)
        .pipe(map((data: any) => {
            return data.arrtopics;
        }))
}

save_obemlevels(obj) {

    obj.clcd=this.clcd;
    obj.aycd=this.aycd;
     obj.usid=this.usid;
    return this.http.post(this._global.baseAPIUrl + 'save_obemlevels',obj)
        .pipe(map((data: any) => {
            return data;
        }))
}


saveposmapped(obj) {

    obj.clcd=this.clcd;
    obj.aycd=this.aycd;
     obj.usid=this.usid;
    return this.http.post(this._global.baseAPIUrl + 'saveposmapped',obj)
        .pipe(map((data: any) => {
            return data;
        }))
}

save_obempo(obj) {

    obj.clcd=this.clcd;
    obj.aycd=this.aycd;
     obj.usid=this.usid;
    return this.http.post(this._global.baseAPIUrl + 'save_obempo',obj)
        .pipe(map((data: any) => {
            return data;
        }))
}


save_obemtmethod(obj) {

    obj.clcd=this.clcd;
    obj.aycd=this.aycd;
    obj.usid=this.usid;
    return this.http.post(this._global.baseAPIUrl + 'save_obemtmethod',obj)
        .pipe(map((data: any) => {
            return data;
        }))
}


save_evlmbatch(obj) {

    obj.clcd=this.clcd;
    obj.aycd=this.aycd;
    obj.usid=this.usid;
    return this.http.post(this._global.baseAPIUrl + 'save_evlmbatch',obj)
        .pipe(map((data: any) => {
            return data;
        }))
}

save_obemco(obj) {

    obj.clcd=this.clcd;
    obj.aycd=this.aycd;
     obj.usid=this.usid;
    return this.http.post(this._global.baseAPIUrl + 'save_obemco',obj)
        .pipe(map((data: any) => {
            return data;
        }))
}

save_obemtpmap(obj) {

    obj.clcd=this.clcd;
    obj.aycd=this.aycd;
     obj.usid=this.usid;
    //  obj.clid=obj1.clid;
    //  obj.suid=obj1.suid;
    //  obj.crid=obj1.crid;
    return this.http.post(this._global.baseAPIUrl + 'save_obemtpmap',obj)
        .pipe(map((data: any) => {
            return data;
        }))
}

upd_obemtpmap_rmks(obj) {

    obj.clcd=this.clcd;
    obj.aycd=this.aycd;
     obj.usid=this.usid;
    //  obj.clid=obj1.clid;
    //  obj.suid=obj1.suid;
    //  obj.crid=obj1.crid;
    return this.http.post(this._global.baseAPIUrl + 'upd_obemtpmap_rmks',obj)
        .pipe(map((data: any) => {
            return data;
        }))
}

save_obetlp(obj) {

    obj.clcd=this.clcd;
    obj.aycd=this.aycd;
     obj.usid=this.usid;
   
    return this.http.post(this._global.baseAPIUrl + 'save_obetlp',obj)
        .pipe(map((data: any) => {
            return data;
        }))
}

masadmyear() {

    let clcd=this.clcd;
    let aycd=this.aycd;
    return this.http.get(this._global.baseAPIUrl + 'getadmyear/'+clcd+'/'+aycd)
        .pipe(map((data: any) => {
            return data.arradmyr;
        }))
}


 votoverview(boothid): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'votoverview/'+this.clcd+'/'+this.aycd+'/'+boothid)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data;
                    
                }));
          }

          saveobemcopo(obj) {

    obj.clcd=this.clcd;
    obj.aycd=this.aycd;
    obj.usid=this.usid;
console.log('data',obj);
    return this.http.post(this._global.baseAPIUrl + 'saveobemcopo',obj)
        .pipe(map((data: any) => {
            console.log('data', data);
            return data;
        }))
}


getposmapped(obj) {

    obj.clcd=this.clcd;
    obj.aycd=this.aycd;
    // obj.oprtype=oprtype;
    return this.http.post(this._global.baseAPIUrl + 'getposmapped',obj)
        .pipe(map((data: any) => {
            console.log('data', data);
            return data.arrobemco;
        }))
}


getobemlpgeneral(obj) {

    obj.clcd=this.clcd;
    obj.aycd=this.aycd;
    // obj.oprtype=oprtype;
    return this.http.post(this._global.baseAPIUrl + 'getobemlpgeneral',obj)
        .pipe(map((data: any) => {
            console.log('data', data);
            return data.arrobemco;
        }))
}


 save_obemlpgeneral(obj,obj1) {

    obj.clcd=this.clcd;
    obj.aycd=this.aycd;
    obj.usid=this.usid;
    obj.clid=obj1.clid;
    obj.suid=obj1.suid;
    obj.crid=obj1.crid;
console.log('data',obj);
    return this.http.post(this._global.baseAPIUrl + 'save_obemlpgeneral',obj)
        .pipe(map((data: any) => {
            console.log('data', data);
            return data;
        }))
}

getobeoverview(obj) {

    obj.clcd=this.clcd;
    obj.aycd=this.aycd;
    obj.usid=this.usid;
    // obj.clid=obj1.clid;
    // obj.suid=obj1.suid;
    // obj.crid=obj1.crid;
console.log('data',obj);
    return this.http.post(this._global.baseAPIUrl + 'getobeoverview',obj)
        .pipe(map((data: any) => {
            console.log('data', data);
            return data.arrinfo;
        }))
}

getobeoverviewstaff(obj) {

    // var obj={clcd:this.clcd,aycd:this.aycd,usid:this.usid};
    obj.clcd=this.clcd;
    obj.aycd=this.aycd;
    obj.usid=this.usid;

console.log('data',obj);
    return this.http.post(this._global.baseAPIUrl + 'getobeoverviewstaff',obj)
        .pipe(map((data: any) => {
            console.log('data', data);
            return data.arrinfo;
        }))
}


getdashstuoverview(obj) {

    obj.clcd=this.clcd;
    obj.aycd=this.aycd;
    obj.usid=this.usid;
    // obj.clid=obj1.clid;
    // obj.suid=obj1.suid;
    // obj.crid=obj1.crid;
console.log('data',obj);
    return this.http.post(this._global.baseAPIUrl + 'dashstudentoverview',obj)
        .pipe(map((data: any) => {
            console.log('data', data);
            return data.arrinfo;
        }))
}


getmentschedules(oprtype,stuid): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
        //    console.log('url',this.callurl + 'getmentschedules/'+this.clcd+'/'+this.aycd+'/'+this.usid+'/'+schdt+'/'+schto+'/'+oprtype)
            
            return this.http.get(this.callurl + 'getmentschedules/'+this.clcd+'/'+this.aycd+'/'+stuid+'/0/0/'+oprtype)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.montschedules;
                    
                }));
          }

          getbatches() {
var obj:any={};
    obj.clcd=this.clcd;
    obj.aycd=this.aycd;
    obj.usid=this.usid;
    return this.http.post(this._global.baseAPIUrl + 'getbatches',obj)
        .pipe(map((data: any) => {
            console.log('data', data);
            return data.arrbatch;
        }))
}


copystudatatohostel(stype): Observable<any> {
            debugger
         var   masclid=localStorage.getItem('masclid');
            
            return this.http.post(this.callurl + 'copystudatatohostel',{clcd:this.clcd,aycd:this.aycd,stype:stype,masclid:masclid,usid:this.usid})
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data;
                    
                }));
          }

}